import { gql } from '@apollo/client';

export interface Input {
  body: String;
  orderId: number;
}

export interface Data {
  id: number
}

const Mutation = gql`
  mutation CreateNote(
    $body: String!
    $orderId: Int!
  ) {
    createNote(
      input: {
        body: $body
        orderId: $orderId
      }
    ) {
      id
    }
  }
`;

export default Mutation
